module.exports = __webpack_public_path__ + "img/thumb_image11.f6ff7fac.jpg";